import locale from 'live/init/global-locale'
import i18n from 'live/services/i18n'
import LoggerFactory from 'live/services/logger'
import serviceLocator from 'live/services/service-locator'

import { IUpdateModeFrontPresenter, UpdateModeFrontAPI } from 'plugin-codaf-risk-ext-bowtie/shared/UpdateModeFrontAPI'
import { IBarrier } from 'plugin-codaf-risk-ext-bowtie/types'

import { enUS, ptBR } from './i18n'
import { QualitativeLiveApi } from './updateMode/QualitativeLiveApi'

export const logger = LoggerFactory('plugin-qualitative-live-event-dra-engine')

const locales = { pt_br: ptBR, en_us: enUS }
i18n.add(locales[locale ?? 'en_us'])

type ILiveApiBarrierConfig = {
    systemId: string
}

function requestValidationArray(barrier: IBarrier): string[] {
    const errorsArray: string[] = []

    const systemId = (barrier.updateModeJsonConfig as ILiveApiBarrierConfig)?.systemId

    if (!systemId || systemId === '') {
        errorsArray.push(i18n('LIVE event ID'))
    }

    return errorsArray
}


const qualitativeLiveApiPresenter: IUpdateModeFrontPresenter = {
    label: 'Qualitative LIVE Event',
    method: 'QUALITATIVE',
    component: QualitativeLiveApi,
    updateModeCode: 'qualitative_live_event',
    validationFunction: requestValidationArray
}

serviceLocator.getService('dra:updatemodefrontservice').then((updateModeFrontAPI: unknown) => {
    try {
        (updateModeFrontAPI as UpdateModeFrontAPI).addUpdateModeFrontPresenter(qualitativeLiveApiPresenter)
        logger.info('front sucesseful registered to DRA engines')
    } catch (e) {
        logger.error(e)
    }
})